import { useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  CircularProgress,
  Box,
} from "@mui/material";
import { Sparkles } from "lucide-react";
import { motion } from "framer-motion";
import Aigif from "../../assets/ai.gif";
import Aiassistant from "../../assets/assistant.gif";

export default function Aisummarizecomment({
  getAISummarizedResultAPI,
  aiSummarizedResult,
  aiSummarizeLoading,
}) {
  return (
    <motion.div
      initial={{ opacity: 0, x: 30 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.4 }}
    >
      <Card
        sx={{
          borderRadius: 3,
          boxShadow: 3,
          background: "linear-gradient(to bottom right, #eff6ff, #ffffff)",
        }}
      >
        <CardContent sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography variant="h6" fontWeight={600}>
              AI Summary
            </Typography>
            <img src={Aigif} className="w-10 h-10" />
          </Box>

          {aiSummarizeLoading ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                py: 4,
                gap: 2,
              }}
            >
              <img src={Aiassistant} className="w-10 h-10" />
              <Typography variant="body2" color="text.secondary">
                AI is analyzing booking comments...
              </Typography>
            </Box>
          ) : aiSummarizedResult && Object.keys(aiSummarizedResult).length > 0 ? (
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ lineHeight: 1.8 }}
            >
              <strong>Current Status:</strong>{" "}
              {aiSummarizedResult?.currentStatus} <br />
              <strong>Summary Points:</strong>
              <ul className="list-disc ml-5">
                {aiSummarizedResult?.summaryPoints?.map((point, index) => (
                  <li key={index}>{point}</li>
                ))}
              </ul>
              <strong>Urgency Level:</strong> {aiSummarizedResult?.urgencyLevel}{" "}
              <br />
              <strong>Next Action:</strong>{" "}
              {aiSummarizedResult?.nextActionRequired}
            </Typography>
          ) : (
            <Typography
              variant="body2"
              color="text.disabled"
              fontStyle="italic"
              sx={{ cursor: "pointer" }}
              onClick={getAISummarizedResultAPI}
            >
              Click here to generate "Booking Comment Summary With AI"
            </Typography>
          )}
        </CardContent>
      </Card>
    </motion.div>
  );
}
